import { Injectable } from '@angular/core';
import { DataCoreService, DlistDto, GetDlist_Request, GetDlist_Response} from '@dabnet-kamu/libs/ui';
import { BehaviorSubject, catchError, finalize, tap, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment as env } from '@dabnet-kamu/libs/ui';
import {ControlConditionModel} from "../../../models/gen-control.model";
@Injectable()
export class TmsAmbarService {
  public _gridControlsList: BehaviorSubject<DlistDto | null> = new BehaviorSubject(null);
    public gridControlsList$ = this._gridControlsList.asObservable();
    public belediyeCode : number;
  yetkiKontrol: boolean=false;
  public isReadOnly!: boolean;
  public isBindCheck!: boolean;
  public controlCondition: ControlConditionModel[];
     constructor(private dataCoreService: DataCoreService,private _httpClient:HttpClient) {}


  setParams(yetkiKontrol: boolean,isReadOnly:boolean, isBindCheck:boolean) {
    this.yetkiKontrol = yetkiKontrol
    this.isReadOnly = isReadOnly;
    this.isBindCheck = isBindCheck;
  }


  getData(code: number,control:any, baseEntity?: string, isSetData?: boolean, yetkiKontrol?:boolean) {
     let dataSource: any;
     let tableName = "";
    const filterArr = [];
      if (this.isBindCheck && this.isReadOnly){
      tableName = control.showEntity?control.showEntity:control.dlistMetadata.baseEntity;
      dataSource = this.dataCoreService.getOData(tableName);
    dataSource.select(['Ad', 'Kod', 'Sifre', 'AktifEh', 'AmbarYerTakipEh']);
    } 
    else{
       if(yetkiKontrol){
         baseEntity = baseEntity + '?AmbarTuru=Y'
       }
       if(!baseEntity){
         return null
       }
      dataSource = this.dataCoreService.getOData(baseEntity);
    dataSource.select(['Ad', 'Kod', 'Sifre', 'AktifEh', 'AmbarYerTakipEh']);
    if(this.controlCondition){
      this.controlCondition.forEach((item:any) => {
        filterArr.push([item.conditionColName, item.conditionColSymbol, item.conditionColText]);
      });
    }
    }
    filterArr.push(['Kod', '=', code]);
    if (filterArr.length > 0) dataSource.filter(filterArr);
    return dataSource;
  }

}
